// Wybuch konfetti z łapek (canvas-confetti). Biblioteka dociąga się dopiero przy pierwszym wybuchu.
import {PAW_PATH} from "./shared";

const COLORS = ["#f0893a", "#ffc845", "#a6d8f7", "#7cc576", "#d1a975", "#472c13"];
let lib = null;

function load() {
    lib ||= import(/* webpackChunkName: "confetti" */ "canvas-confetti").then(({default: confetti}) => ({
        confetti,
        paw: confetti.shapeFromPath({path: PAW_PATH})
    }));
    return lib;
}

export async function pawBurst(x, y, {count = 60, spread = 75, velocity = 38} = {}) {
    const {confetti, paw} = await load();
    confetti({
        particleCount: count,
        spread,
        startVelocity: velocity,
        gravity: 0.9,
        ticks: 240,
        scalar: 1.6,
        origin: {x: x / window.innerWidth, y: y / window.innerHeight},
        shapes: [paw, paw, "circle"],
        colors: COLORS,
        zIndex: 100,
        disableForReducedMotion: true
    });
}

/** Wybuch ze środka elementu (np. przycisku). */
export function pawBurstFrom(el, options) {
    const r = el.getBoundingClientRect();
    return pawBurst(r.left + r.width / 2, r.top + r.height / 2, options);
}
